import {Component, inject, OnInit, signal, ViewChild} from '@angular/core';
import {CustomErrorComponent} from "../../../../shared/commons/custom-error.component";
import {FormsModule, NgForm} from "@angular/forms";
import {NgIf, SlicePipe} from "@angular/common";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {
  DigitalAddressDto,
  DigitalAddressSearchParams,
  Page,
  PrisonerFundDto
} from "../../../../../generated-model/model";
import {DigitalAddressResource} from "../../../../service/DigitalAddressResource";
import {PageRequest, updateFormAndValidity} from "../../../../app.constants";
import {ThaiDateTimePipe} from "../../../../shared/commons/thai-datetime.pipe";

@Component({
  selector: 'app-digital-address',
  standalone: true,
  imports: [
    CustomErrorComponent,
    FormsModule,
    NgIf,
    NgbPagination,
    NotFoundComponent,
    SharedCommonModule,
    ThaiDateTimePipe,
  ],
  templateUrl: './digital-address.component.html',
  styleUrl: './digital-address.component.scss'
})
export class DigitalAddressComponent implements OnInit {
  @ViewChild("form", {read: NgForm, static: true}) form: NgForm;
  digitalAddressParams:DigitalAddressSearchParams={};
  digitalAddressResource = inject(DigitalAddressResource);
  pageData: Page<DigitalAddressDto> = {number: 0, size: 10};
  typeSearch=signal(true);

  ngOnInit(): void {
    this.clearSearchParams();
  }

  updateSearchType(value: boolean) {
    this.typeSearch.set(value);
    this.pageData = {number: 0, size: 10, content: []};
    this.clearSearchParams();
  }

  clearSearchParams() {
    this.digitalAddressParams = {};
  }

  search(page:number=1) {
    const pageRequest: PageRequest = {page: page - 1, size: this.pageData.size}
    let formValid = updateFormAndValidity(this.form);
    if(formValid){
      this.digitalAddressResource.search(this.digitalAddressParams, pageRequest).subscribe({
        next: e => {
          this.pageData = e;
        }
      })
    }
  }

  protected readonly onsubmit = onsubmit;
}
